(function () {
  'use strict';

  if (window.__egUpcartSyncInstalled) return;
  window.__egUpcartSyncInstalled = true;

  var nativeFetch = window.fetch;
  var nativeXhrOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var nativeXhrSend = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  var refreshTimer = null;

  function isCartMutation(input, options) {
    var url = typeof input === 'string' ? input : input && input.url;
    var method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();

    if (!url || method === 'GET' || method === 'HEAD') return false;

    try {
      var pathname = new URL(url, window.location.origin).pathname;
      // Some UpCart builds do not emit their public update event after the
      // theme submits /cart/add.js, so cover every cart mutation here.
      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathname);
    } catch (error) {
      return false;
    }
  }

  function notifyCartChanged(cart) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      document.querySelectorAll('[data-js-cart-count]').forEach(function (element) {
        element.textContent = cart.item_count;
      });

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart }
      }));

      // UpCart exposes this only in installations where its public API is
      // available to theme scripts. The DOM event remains the compatibility
      // path for newer bridge builds.
      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
      }
    }, 100);
  }

  function isCompleteCart(cart) {
    return cart &&
      Array.isArray(cart.items) &&
      typeof cart.item_count === 'number' &&
      typeof cart.total_price === 'number';
  }

  function getCurrentCart() {
    if (typeof nativeFetch === 'function') {
      nativeFetch.call(window, '/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (cartResponse) {
        return cartResponse.ok ? cartResponse.json() : null;
      }).then(function (cart) {
        if (isCompleteCart(cart)) notifyCartChanged(cart);
      }).catch(function () {});
      return;
    }

    if (!nativeXhrOpen || !nativeXhrSend) return;

    var request = new XMLHttpRequest();
    nativeXhrOpen.call(request, 'GET', '/cart.js', true);
    request.addEventListener('load', function () {
      if (request.status < 200 || request.status >= 300) return;
      try {
        var cart = JSON.parse(request.responseText);
        if (isCompleteCart(cart)) notifyCartChanged(cart);
      } catch (error) {}
    });
    nativeXhrSend.call(request);
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var responsePromise = nativeFetch.apply(this, args);

      if (!isCartMutation(args[0], args[1])) return responsePromise;

      responsePromise.then(function (response) {
        if (!response || !response.ok) return;

        response.clone().json().then(function (cart) {
          if (isCompleteCart(cart)) {
            notifyCartChanged(cart);
          } else window.setTimeout(getCurrentCart, 150);
        }).catch(function () {
          window.setTimeout(getCurrentCart, 150);
        });
      }).catch(function () {});

      return responsePromise;
    };
  }

  if (nativeXhrOpen && nativeXhrSend) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__egCartMutation = isCartMutation(url, { method: method });
      return nativeXhrOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__egCartMutation) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;

          var cart = null;
          try {
            cart = this.responseType === 'json' ? this.response : JSON.parse(this.responseText);
          } catch (error) {}

          if (isCompleteCart(cart)) {
            notifyCartChanged(cart);
          } else {
            window.setTimeout(getCurrentCart, 150);
          }
        });
      }

      return nativeXhrSend.apply(this, arguments);
    };
  }
})();
